import { useSyncExternalStore } from 'react';
import { loadOperatorLinks, subscribe, type OperatorLinks } from './store';

/** Reactive view of the casino's lobby/deposit URLs (null until known). */
export function useOperatorLinks(): OperatorLinks {
  return useSyncExternalStore(subscribe, loadOperatorLinks, loadOperatorLinks);
}
